export default __webpack_public_path__ + "static/media/heart-fill.0cb3bae1.svg";